import { ValidationArguments, ValidatorConstraint, ValidatorConstraintInterface, Validator } from 'class-validator';
import { CustomCommonValidator } from './customCommonValidator';

@ValidatorConstraint()
export class UserDynamicPropertyValidation extends CustomCommonValidator implements ValidatorConstraintInterface {

	validate(dynamicProperties: any, validationArguments: ValidationArguments) {
		let properties: string[] = Object.getOwnPropertyNames(dynamicProperties);
		let result: boolean = true;
		const validator = this.getValidator();
		this.message = '';

		if (properties.find(p => p == 'telephone') != null) {
			let mobilePhone: string = dynamicProperties['telephone'];
			if (!validator.matches(mobilePhone, /\(?\d+\)?[-.\s]?\d+[-.\s]?\d+$/)) {
				result = false;
				this.message = this.message.concat(' Telephone is incorrect <br />');
			}
		}
		return result;
	}

	defaultMessage(args: ValidationArguments) { // here you can provide default error message if validation failed
		return this.message;
	}

}



// WEBPACK FOOTER //
// ./src/core/customValidator/userDynamicPropertyValidator.ts